import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { FailedUrlsAction } from 'redux/actions';
import { ConvertUtcToLocal } from 'hooks';
import PageSpinner from 'components/PageSpinner';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import { Form, Input, Button, Card, CardBody } from 'reactstrap';
import { MdWebAssetOff, MdWebAsset } from 'react-icons/md';
import Avatar from 'components/Avatar';
import noImage from 'assets/img/users/no-image.jpg';


const FailedUrls = (props) => {

    const [failedType, setFailedType] = React.useState('');
    const [pagination, setPagination] = React.useState({
        page: 0,
        page_limit: 10,
    });
    const [order, setOrder] = React.useState({
        order_by: `created_at`,
        direction: 'desc'
    });
    const fetchFailedUrls = (filters) => {
        props.getFailedUrls(filters);
    }

    React.useEffect(() => {
        let filters = {
            page: pagination.page,
            page_limit: pagination.page_limit,
            order_by: order.order_by,
            direction: order.direction,
            failedType: failedType
        };
        fetchFailedUrls(filters)
    }, [pagination, order]);


    React.useEffect(() => {
        setOrder({
            order_by: `created_at`,
            direction: 'desc'
        });
        setPagination({
            page: 0,
            page_limit: 10,
        });
    }, [failedType])


    const profilePicture = (value) => {
        return (<div>
            <Avatar src={((value && value.user && value.user.avatar)) ? value.user.avatar : noImage} />
            <div>{(value && value.user && value.user.username) ? value.user.username : ''}</div>
        </div>);
    }

    const columns = () => {
        const cols = [
            {
                name: "post",
                label: "User",
            },
            {
                name: "url",
                label: "Url",
            },
            {
                name: "device_type",
                label: "Device",
            },
            {
                name: "device_os",
                label: "Device OS",
            },
            {
                name: "failed_in_curl",
                label: "Failed In Curl",
            },
            {
                name: "scrap_by_script",
                label: "Attampted In Enrichment",
            },
            {
                name: "failed_in_enrichment",
                label: "Failed In Enrichment",
            },
            {
                name: "created_at",
                label: "Created At",
            },
            {
                name: "resolved_at",
                label: "Resolved At",
            },
            {
                name: "last_retried_at",
                label: "Retried At",
            }

        ];
        return cols.map((column, index) => {
            return {
                label: column.label,
                name: column.name,

                options: {
                    display: (column.name === 'device_os') ? false : true,
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    /*setCellProps: () => ({
                        style: (column.name === 'url' || column.name === 'host') ?
                            { minWidth: "250px", maxWidth: "250px", wordBreak: "break-all" } :
                            (column.name === 'post' || column.name === 'failed_in_curl' || column.name === 'scrap_by_script' || column.name === 'failed_in_enrichment') ?{ minWidth: "50px", maxWidth: "50px"}:
                            { width: 'auto' }
                    }),*/
                    setCellProps: () => ({
                        style: (column.name === 'post') ? { textAlign: "center" }
                            : (column.name === 'url') ? { minWidth: "250px", maxWidth: "250px", wordBreak: "break-all" }
                                : { width: 'auto' }
                    }),
                    customBodyRender: (value, tableMeta, updateValue) => {

                        return (tableMeta.columnData.name === 'created_at' || tableMeta.columnData.name === 'resolved_at' || tableMeta.columnData.name === 'last_retried_at') ?  ConvertUtcToLocal(value, 'MM-DD-YYYY HH:mm:ss')
                            : (tableMeta.columnData.name === 'url') ? <>{(tableMeta.rowData[8]) ? <MdWebAsset style={{ color: '#00aee4', fontSize: 23 }} /> : <MdWebAssetOff style={{ color: '#fa5c7d', fontSize: 20 }} />} {value}</>
                                : (tableMeta.columnData.name === 'failed_in_curl') ? (value) ?
                                    <Button color="secondary" size={'sm'} disabled={true}>YES</Button> : <Button size={'sm'} color="primary" disabled={true}>No</Button>
                                    : (tableMeta.columnData.name === 'scrap_by_script') ? (value) ? <Button color="primary" size={'sm'} disabled={true}>YES</Button> : <Button size={'sm'} color="primary" disabled={true}>No</Button>
                                        : (tableMeta.columnData.name === 'failed_in_enrichment') ? (value) ? <Button color="secondary" size={'sm'} disabled={true}>YES</Button> : <Button size={'sm'} color="primary" disabled={true}>No</Button>
                                            : (tableMeta.columnData.name === 'post') ? profilePicture(value)
                                                : (tableMeta.columnData.name === 'device_type') ? <><div>{value}</div><div>{tableMeta.rowData[3]}</div></>
                                                    : value;
                    }
                }
            }
        })
    }
    const options = {
        tableId: 'datatable',
        filterType: 'checkbox',
        search: false,
        responsive: "simple",
        filter: false,
        download: false,
        print: false,
        selectableRows: 'none',
        viewColumns: false,
        count: props.totalCount,
        serverSide: (props.serverSide !== undefined) ? props.serverSide : true,
        page: pagination.page,
        rowsPerPage: pagination.page_limit,
        setRowProps: (row, dataIndex, rowIndex) => {
            return {
                style: (ConvertUtcToLocal(row[8], 'MM-DD-YYYY') && ConvertUtcToLocal(row[7], 'MM-DD-YYYY') !== ConvertUtcToLocal(row[8], 'MM-DD-YYYY')) ? { background: '#00aee463' } : { background: 'auto' },
            };
        },
        onColumnSortChange: (changedColumn) => {
            setOrder({
                order_by: changedColumn,
                direction: (order.direction === 'asc') ? 'desc' : 'asc'
            })
        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPagination({
                        page_limit: pagination.page_limit,
                        page: tableState.page
                    })
                    break;
                case 'changeRowsPerPage':
                    setPagination({
                        page_limit: tableState.rowsPerPage,
                        page: 0,
                    })
                    break;
                default:
                    break
            }
        }
    };
    return (
        <Card>
            <CardBody>
                <Form>
                    <Input onChange={(e) => setFailedType(e.target.value)} className="mb-2" type="select" defaultValue={failedType} style={{ width: 200 }}>
                        <option value={''}>All</option>
                        {[{ label: 'Failed In Enrichment Service', value: 1 }].map((item) => (<option key={item.value} value={item.value}>{item.label}</option>))}
                    </Input>
                </Form>
                {props.isLoading ? <PageSpinner />
                    : <DataTables data={props.failedUrls} columns={columns()} options={options} />
                }
            </CardBody>
        </Card>
    );
}


const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    failedUrls: (state.failedUrls && state.failedUrls.urls && state.failedUrls.urls.data) ? state.failedUrls.urls.data : [],
    totalCount: (state.failedUrls && state.failedUrls.urls && state.failedUrls.urls.totalCount) ? state.failedUrls.urls.totalCount : 0,
});
const mapDispatchToProps = (dispatch) => ({
    getFailedUrls: (payload) => dispatch(FailedUrlsAction.getFailedUrls(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FailedUrls);
